<template>
  <!-- 報到 - 會議資訊 - 住戶列表 - 出席名單 -->
  <div id="RegisterList_main">
    <FilterFrame
      v-if="showFilter"
      ref="filter"
      :filter-form="filterForm"
      @search="search"
      @clear="clearSearch()"
    />
    <div
      v-if="showControlWrap"
      class="controlWrap"
    >
      <div class="left">
        <el-radio-group v-model="displayType">
          <el-radio-button
            :key="0"
            :label="0"
          >
            <i
              class="icon-menu-grid"
              aria-hidden="true"
            />
          </el-radio-button>
          <el-radio-button
            :key="1"
            :label="1"
          >
            <i
              class="icon-list"
              aria-hidden="true"
            />
          </el-radio-button>
        </el-radio-group>
        <div class="circle" />
        <div class="circle-span">
          已報到
        </div>
        <div class="circle orange" />
        <div class="circle-span">
          已簽退
        </div>
      </div>
      <div class="right">
        <span>搜尋結果共計 {{ listData.length }} 筆</span>
        <el-button
          icon="icon-output"
          round
          @click="exportExcel"
        >
          匯出
        </el-button>
      </div>
    </div>
    <!-- 顯示模式1：區塊顯示 -->
    <div v-show="displayType === 0">
      <div
        v-if="listData.length > 0"
        class="card_main"
      >
        <div
          v-for="(item , index) in listData"
          :key="index"
          class="card"
          @click="$refs.detailDialog.openDetailDialog(item)"
        >
          <el-card
            :class="[item.registrationStatus === 'Registered' ? 'bg_green' : '',item.registrationStatus === 'Unregistered' ? 'bg_orange' : '']"
            shadow="hover"
          >
            <div slot="header">
              <span>{{ item.tabletName }}</span>
            </div>
            <div>
              <p>{{ areaPerPerson }}：{{ item.tabletArea }} {{ unit }}</p>
              <p>區分所有權佔比：{{ item.tabletAreaRatio }}％</p>
              <div
                v-if="showButton"
                class="buttonWrap"
              >
                <el-button
                  v-if="item.registrationStatus === 'Registered'"
                  size="mini"
                  plain
                  @click.stop="openRegisterDialog('簽退', item)"
                >
                  簽退
                </el-button>
                <el-button
                  v-if="item.registrationStatus === 'Registered'"
                  class="cancelRegister-button"
                  size="mini"
                  plain
                  @click.stop="cancelRegister(item, index)"
                >
                  取消報到
                </el-button>
                <el-button
                  v-if="item.registrationStatus === 'NotRegistered'"
                  type="primary"
                  size="mini"
                  plain
                  @click.stop="openRegisterDialog('報到', item)"
                >
                  報到
                </el-button>
                <el-button
                  v-if="item.registrationStatus === 'Unregistered'"
                  size="mini"
                  plain
                  @click.stop="cancelUnregistration(item)"
                >
                  取消簽退
                </el-button>
              </div>
            </div>
          </el-card>
        </div>
      </div>
      <div v-else-if="!loading">
        <span>查無資料</span>
      </div>
    </div>
    <!-- 顯示模式2：列表顯示 -->
    <el-table
      v-show="displayType === 1"
      id="tableId"
      class="list"
      :data="listData"
    >
      <el-table-column
        type="index"
        width="60"
      />
      <el-table-column
        prop="tabletName"
        label="戶別"
      />
      <el-table-column
        v-if="showRegistration"
        label="出席狀態"
        min-width="60"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.registrationStatus === 'NotRegistered'"
            type="info"
          >
            未報到
          </el-tag>
          <el-tag
            v-else-if="scope.row.registrationStatus === 'Registered'"
            type="success"
          >
            已報到
          </el-tag>
          <el-tag
            v-else
            type="warning"
          >
            已簽退
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="unitOwnerName"
        label="區權人姓名"
      />
      <el-table-column
        prop="tabletArea"
        :label="`${areaPerPerson}（${unit}）`"
        min-width="70"
      />
      <el-table-column label="區分所有權佔比">
        <template slot-scope="scope">
          <span>{{ scope.row.tabletAreaRatio }}％</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="showRegistration"
        label="報到人身份"
        min-width="60"
      >
        <template
          v-if="scope.row.registrationStatus !== 'NotRegistered'"
          slot-scope="scope"
        >
          <span v-if="scope.row.isRepresented">委託</span>
          <span v-else>本人</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="showRegistration"
        label="報到時間"
        min-width="50"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.registerAt !== ''">{{ scope.row.registerAt }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="showRegistration"
        label="簽退時間"
        min-width="50"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.unregisterAt !== ''">{{ scope.row.unregisterAt }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="showButton"
        label="操作"
        width="190"
      >
        <template
          slot-scope="scope"
          class="buttonWrap"
        >
          <el-button
            v-if="scope.row.registrationStatus === 'Registered'"
            size="mini"
            plain
            @click="openRegisterDialog('簽退', scope.row)"
          >
            簽退
          </el-button>
          <el-button
            v-if="scope.row.registrationStatus === 'Registered'"
            class="cancelRegister-button"
            size="mini"
            plain
            @click="cancelRegister(scope.row, scope.$index)"
          >
            取消報到
          </el-button>
          <el-button
            v-if="scope.row.registrationStatus === 'NotRegistered'"
            type="primary"
            size="mini"
            plain
            @click="openRegisterDialog('報到', scope.row)"
          >
            報到
          </el-button>
          <el-button
            v-if="scope.row.registrationStatus === 'Unregistered'"
            size="mini"
            plain
            @click="cancelUnregistration(scope.row)"
          >
            取消簽退
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <TableLoading :is-loading="loading" />
    <RegisterDetailDialog ref="detailDialog" />
    <RegisterDialog
      ref="registerDialog"
      @tablet-value-add="tabletValueAdd"
      @unregister-value-add="unregisterValueAdd"
    />
  </div>
</template>

<script>
import TableLoading from '@/components/TableLoading'
import FilterFrame from '@/components/FilterFrame'
import RegisterDetailDialog from './RegisterDetailDialog'
import RegisterDialog from './RegisterDialog'
import tw from '../utils'

export default {
  components: {
    FilterFrame,
    RegisterDetailDialog,
    RegisterDialog,
    TableLoading
  },
  props: {
    showFilter: true,
    showControlWrap: true,
    showRegistration: true,
    showButton: true,
    displayMode: 0
  },
  data () {
    const { areaPerPerson, unit } = tw
    return {
      areaPerPerson,
      unit,
      loadingObj: null,
      displayType: 0, // 0區塊、1列表
      filterForm: [
        {
          label: '戶別',
          name: 'household',
          type: 'houseNoVirtual'
        },
        {
          label: '出席狀態',
          name: 'registrationStatus',
          type: 'select',
          options: [
            {
              value: 0,
              label: '未報到'
            },
            {
              value: 1,
              label: '已報到'
            },
            {
              value: 2,
              label: '已簽退'
            }
          ],
          value: ''
        },
        {
          label: '報到時間',
          name1: 'registrationInterval.startTime',
          name2: 'registrationInterval.endTime',
          type: 'time',
          control: {
            showEndTime: true,
            placeholder1: '開始時間',
            pickerOptions1: {
              start: '06:00',
              end: '22:00',
              step: '00:30'
            },
            placeholder2: '結束時間',
            pickerOptions2: {
              start: '06:00',
              end: '22:00',
              step: '00:30'
            }
          }
        }
      ],
      listData: [],
      filter: {},
      canClickButton: true,
      loading: false,
      canOpenDetailDialog: true,
      forceCancelConfirm: '取消此戶報到會議人數將低於法定出席標準，<span style="color: #c44536; font-weight:bold;">會議目前所有議題表決都會重置</span>，請問是否仍要取消此戶報到。'
    }
  },
  mounted () {
    this.getListData()
    // this.getComTag()
    if (this.displayMode) { this.displayType = this.displayMode }
  },
  methods: {
    // 查詢
    search (such_val) {
      if (this.canClickButton && !this.loading) {
        this.canClickButton = false
        this.filter.household = such_val.household === undefined ? '' : such_val.household.TabletId
        this.filter.registrationStatus = such_val.registrationStatus === undefined ? 3 : such_val.registrationStatus
        this.filter['registrationInterval.startTime'] = such_val['registrationInterval.startTime'] === undefined || such_val['registrationInterval.startTime'] === null ? '' : '2022-01-27T' + such_val['registrationInterval.startTime'] + 'Z'
        this.filter['registrationInterval.endTime'] = such_val['registrationInterval.endTime'] === undefined || such_val['registrationInterval.endTime'] === null ? '' : '2022-01-27T' + such_val['registrationInterval.endTime'] + 'Z'
        this.getListData()
      }
    },
    // 清除搜尋條件
    clearSearch () {
      if (this.canClickButton && !this.loading) {
        this.canClickButton = false
        this.filter = {}
        this.loading = true
        this.getListData()
      }
    },
    // 取得列表資料
    getListData () {
      apiUnitOwnerAssembly.GetUnitOwnerList(
        {
          AssemblyId: this.$route.params.id || this.$route.query.id,
          'Filter.TabletId': this.filter.household,
          'Filter.RegistrationStatus': ['NotRegistered', 'Registered', 'Unregistered', ''][this.filter.registrationStatus],
          'Filter.StartTime': this.filter['registrationInterval.startTime'],
          'Filter.DueTime': this.filter['registrationInterval.endTime']
        }
      ).then(res => {
        res.data.map(item => item.tabletAreaRatio = (item.tabletAreaRatio * 100).toFixed(2) < 0.01 ? '＜0.01' : (item.tabletAreaRatio * 100).toFixed(2))
        this.listData = res.data
        this.loading = false
        this.canClickButton = true
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    tabletValueAdd (id, identity) {
      // 避免 foreach 找到後繼續跑的情形
      for (const item of this.listData) {
        if (id === item.id) {
          item.registrationStatus = 'Registered'
          // eslint-disable-next-line eqeqeq
          item.isRepresented = identity != '本人'
          item.registerAt = this.$newFormatDate(new Date()).substring(11, 16)
          this.$emit('tablet-value-add', item)
          break
        }
      }
      this.fullScreenLoading(false)
    },
    unregisterValueAdd (id) {
      this.fullScreenLoading(false)
      console.log(id)
      this.listData.forEach(item => {
        if (id === item.id) {
          item.registrationStatus = 'Unregistered'
          item.unregisterAt = this.$newFormatDate(new Date()).substring(11, 16)
          this.$emit('unregister-value-add')
        }
      })
    },
    // 報到 & 簽退
    openRegisterDialog (actiontype, data) {
      if (!this.canClickButton) { return }
      this.fullScreenLoading(true)
      this.$refs.registerDialog.openDialog(actiontype, data)
    },
    // 取消報到
    cancelRegister (item, index) {
      console.log(item)
      this.canOpenDetailDialog = false
      this.$confirm('確認取消報到？', '警告', {
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 取消報到點擊確認後 loading
        this.fullScreenLoading(true)
        apiUnitOwnerAssembly.Register.CancelUnitOwnerRegistration(
          {
            assemblyId: this.$route.params.id,
            unitOwnerId: item.id
          }
        ).then((res) => {
          console.log(res)
          // eslint-disable-next-line eqeqeq
          if (res.status == 200) {
            this.$message.success('取消報到成功！')
            // 我認為有可能是因爲直接修改傳進來的資料而非修改 data 裡的 listData，因此有時才會出現狀態無即時異動的情形
            this.listData[index].registrationStatus = 'NotRegistered'
            this.listData[index].registerAt = ''
            // item.registrationStatus = 'NotRegistered'
            // item.registerAt = ''
            this.$emit('cancel-register', item.tabletArea, item.tabletAreaRatio)
          }
          // 取消報到成功後關閉 loading
          this.fullScreenLoading(false)
        }).catch((err) => {
          // 取消報到失敗後關閉 loading
          this.fullScreenLoading(false)
          console.log('錯誤訊息：', err.response)
          if (err.response.status >= 400) {
            // eslint-disable-next-line eqeqeq
            if (err.response.data.description == '此狀態下不能取消報到') { this.$message.error('會議已開始表決，無法取消報到。') } else if (err.response.data.description == '取消報到將回朔會議狀態') {
              // 取消報到例外流程
              this.$confirm(this.forceCancelConfirm, '警告', {
                confirmButtonText: '否',
                cancelButtonText: '是',
                type: 'warning',
                dangerouslyUseHTMLString: true,
                // showClose: false,
                distinguishCancelAndClose: true
                // 羿臻想要此 confirm 其中一段文字為紅色粗體字
              }).then(() => {
                // confirmButtonText: '否',
                console.log('純粹關閉彈窗')
              }).catch((e) => {
                console.log('cancelTest', e)
                // cancelButtonText: '是',
                if (e === 'cancel') {
                  console.log('取消報到將回朔會議狀態')
                  apiUnitOwnerAssembly.Assembly.ResetAssembly(
                    {
                      data: { assemblyId: this.$route.params.id },
                      'content-type': 'application/json'
                    }
                  ).then(() => {
                    console.log('重置會議囉')
                    apiUnitOwnerAssembly.Register.CancelUnitOwnerRegistration(
                      {
                        assemblyId: this.$route.params.id,
                        unitOwnerId: item.id
                      }
                    ).then((res) => {
                      console.log(res)
                      // eslint-disable-next-line eqeqeq
                      if (res.status == 200) {
                        this.$message.success('取消報到成功！')
                        item.registrationStatus = 'NotRegistered'
                        item.registerAt = ''
                        this.$emit('cancel-register', item.tabletArea, item.tabletAreaRatio)
                      }
                      this.fullScreenLoading(false)
                    }).catch(() => {
                      this.$message.error('發生未知錯誤，請稍後再試')
                    })
                  }).catch(() => {
                    this.$message.error('發生未知錯誤，請稍後再試')
                  })
                }
              })
            } else { this.$message.error('發生未知錯誤，請稍後再試') }
          }
        })
        this.canOpenDetailDialog = true
      }).catch(() => {
        this.canOpenDetailDialog = true
      })
    },
    // 取消簽退
    cancelUnregistration (item) {
      console.log(item)
      this.canOpenDetailDialog = false
      this.$confirm('確認取消簽退？', '警告', {
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullScreenLoading(true)
        apiUnitOwnerAssembly.Register.CancelUnitOwnerUnregistration(
          {
            assemblyId: this.$route.params.id,
            unitOwnerId: item.id
          }
        ).then((res) => {
          console.log(res)
          // eslint-disable-next-line eqeqeq
          if (res.status == 200) {
            this.$message.success('取消簽退成功！')
            item.registrationStatus = 'Registered'
            item.unregisterAt = ''
            this.$emit('cancel-unregistration')
          }
          this.fullScreenLoading(false)
        }).catch((err) => {
          this.fullScreenLoading(false)
          console.log('錯誤訊息：', err.response)
          if (err.response.status >= 400) {
            this.$message.error('發生未知錯誤，請稍後再試')
          }
        })
        this.canOpenDetailDialog = true
      }).catch(() => {
        this.canOpenDetailDialog = true
      })
    },
    // 匯出excel
    exportExcel () {
      this.$refs.filter.onSearch()
      const requestData = {
        AssemblyId: this.$route.params.id,
        'Filter.TabletId': this.filter.household,
        'Filter.RegistrationStatus': ['NotRegistered', 'Registered', 'Unregistered', ''][this.filter.registrationStatus],
        'Filter.StartTime': this.filter['registrationInterval.startTime'],
        'Filter.DueTime': this.filter['registrationInterval.endTime']
      }
      apiUnitOwnerAssembly.GetRegistrationExport(
        requestData,
        {
          responseType: 'blob'
        }
      ).then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', '出席名單.xlsx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    // 判斷刷新機制是否可進行
    canOpenRefreshTimer () {
      if (this.$refs.detailDialog.dialogVisible || this.$refs.registerDialog.dialogVisible) { return true } else { return false }
    },
    // 全屏loading畫面
    fullScreenLoading (display) {
      if (display) {
        // 要純手動控制開關
        // 如果要顯示
        this.loadingObj = this.$loading({
          lock: true,
          text: '資料處理中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        this.canClickButton = false
      } else {
        // const delay = process.env.NODE_ENV === 'development' ? 0 : 800
        const delay = 800
        // 如果要關掉就在 800 豪秒後關掉
        setTimeout(() => {
          this.canClickButton = true
          if (this.loadingObj) this.loadingObj.close()
        }, delay)
      }
    }
  }
}
</script>
<style lang="sass" scoped>
#RegisterList_main
  .controlWrap
    display: inline-block
    width: 100%
    padding: 15px 0
    .left
      float: left
      .el-checkbox-group
        text-align: right
        margin-top: 10px
      .circle
        display: inline-block
        width: 22px
        height: 22px
        border-radius: 45px
        background-color: #e3f1eb
        position: relative
        top: 5px
        margin: 0 10px 0 20px
        &.orange
          background-color: #fff2e5
      .circle-span
        display: inline-block
        font-size: 16px
        line-height: 41px
    .right
      float: right
      .el-button
        margin-left: 10px
  .card_main
    display: flex
    flex-wrap: wrap
    justify-content: center
    .card
      width: 260px
      margin: 10px
      cursor: pointer
    ::v-deep .el-card
      background-color: #f7f7f7
      border-color: $white
      .el-card__header
          border-color: $white
      &.bg_green
        background-color: #e3f1eb
      &.bg_orange
        background-color: #fff2e5
      .el-card__header
        font-size: 20px
        border-color: $white
      .el-card__body
        // height: 98px
        font-size: 18px
        line-height: 28px
        .el-button
          margin-top: 10px
  ::v-deep .el-table
    +basicTable
    .el-tag.el-tag--warning
      color: $warnColor
    .el-input
      width: 120px
      font-size: 15px
      text-align: left
      .el-input__inner
        text-align: left
        line-height: 1px
      input::-webkit-outer-spin-button,input::-webkit-inner-spin-button
        -webkit-appearance: none
        margin: 0
      &.borderRed
        .el-input__inner
          border: $dangerColorHover 1px solid
  .buttonWrap
    .el-button
      z-index: 100
  .cancelRegister-button
    border: #666 1px solid
    color: $subFontColor

</style>
